import * as React from "react";
import { ReactNode } from "react";
import {
	Burger,
	Container,
	createStyles,
	Group,
	Stack,
	useMantineTheme,
	Text,
} from "@mantine/core";

import { _NavItem, translate } from "./_GlobalNav";
import _ExternalNavElement from "./_ExternalNav";

const useStyles = createStyles((_theme, _params) => ({
	navbar: {
		minHeight: "3.5rem",
		color: "white",
		width: "100%",
		boxShadow: _theme.shadows.sm,
	},
	logoLine: {
		padding: "0.75rem 0",
	},
	logo: {
		filter: "invert() contrast(234234)",
		height: "2rem",
		paddingRight: "1.25rem",
	},
	title: {
		fontWeight: 400,
		fontSize: "1.25rem",
	},
	separator: {
		width: "3.152rem",
		border: "0.5px solid white",
	},
	verticalSeparator: {
		height: "1.25rem",
		border: "0.5px solid white",
	},
	mobileLanguage: {
		textTransform: "uppercase",
		cursor: "pointer",
	},
}));

interface Props {
	selectedLanguage: "en" | "de" | string;
	languages?: { key: string; label: string }[];
	onLanguageSelect: (language: string) => void;
	appNav: _NavItem[];
	title: string;
	makeWrapper?: (url: string | undefined, child: ReactNode) => ReactNode;
  loginButton?: ReactNode;
  signet?: string;
}
const _BottomHeader: React.FC<Props> = ({
	selectedLanguage,
	onLanguageSelect,
	languages,
	appNav,
	title,
	makeWrapper,
  loginButton,
  signet,
}) => {
	const { classes } = useStyles();

	const theme = useMantineTheme();
	const [opened, setOpened] = React.useState(false);

	return (
		<Container
			className={classes.navbar}
			fluid={true}
			sx={(theme: any) => {
				return {
					backgroundColor: theme.colors.vsethMain?.[7],
				};
			}}
		>
			<Group className={classes.logoLine} align="center" position="apart">
				<div style={{ display: "flex" }}>
					<img
						src={signet ? signet : "https://static.vseth.ethz.ch/assets/vseth-0000-vseth/signet-mono.svg"}
						className={classes.logo}
					/>
					<div className={classes.title}>
						{makeWrapper ? (
							makeWrapper("/", title)
						) : (
							<a style={{ color: "inherit", textDecoration: "none" }} href="/">
								{title}
							</a>
						)}
					</div>
				</div>

				<Burger
					opened={opened}
					onClick={() => setOpened((o: boolean) => !o)}
					size="sm"
					color={theme.colors.gray[0]}
					mr="xl"
				/>
			</Group>
			{opened ? (
				<Stack align="center" spacing="0.625rem" py="0.625rem">
					{translate(appNav, selectedLanguage).map((item, i) => {
						return (
							<>
								<div key={i} onClick={() => setOpened(false)}>
									<_ExternalNavElement
										item={item}
										lightBg={false}
										makeWrapper={makeWrapper}
										mobile={true}
									/>
								</div>
								{i !== appNav.length - 1 ? (
									<div className={classes.separator} />
								) : undefined}
							</>
						);
					})}
					{languages ? (
						<Group>
							{languages.map((lang, i) => (
								<>
									<Text
										className={classes.mobileLanguage}
										onClick={() => {
											onLanguageSelect(lang.key);
										}}
									>
										{lang.key}
									</Text>
									{i !== languages.length - 1 ? (
										<div className={classes.verticalSeparator} />
									) : undefined}
								</>
							))}
						</Group>
					) : undefined}
          {loginButton}
				</Stack>
			) : undefined}
		</Container>
	);
};

export default _BottomHeader;
